import React from "react";

interface HelpFieldWrapperProps<FieldKey extends string> {
  fieldKey: FieldKey;
  onFocus: (fieldKey: FieldKey) => void;
  /** Radio groups move the guidance on click only, so their own focus events are left alone. */
  clickOnly?: boolean;
  className?: string;
  children: React.ReactNode;
}

/** Marks a drawer field so focusing or clicking it shows that field's guidance. */
export const HelpFieldWrapper = <FieldKey extends string>({ fieldKey, onFocus, clickOnly = false, className, children }: HelpFieldWrapperProps<FieldKey>) => (
  <div className={className} data-help-field={fieldKey} onFocus={clickOnly ? undefined : () => onFocus(fieldKey)} onClick={() => onFocus(fieldKey)}>
    {children}
  </div>
);
